// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","455":"5d9c9b03","488":"b51d605a","977":"37d9e8f3"}[chunkId] + ".chunk.js";
};